module.exports = __webpack_public_path__ + "static/img/IMG_20160311_154702.b78df261.jpg";